import DesktopSegmentsConfig from "segments/desktop";
import MobileSegmentsConfig from "segments/mobile";
export const getSegmentsConfigs = (isMobile)=>{
    return isMobile ? MobileSegmentsConfig : DesktopSegmentsConfig;
};
